import React from "react";
import { Card, CardHeader, CardContent, CardDescription } from "components/ui/card";
import { Input } from "components/ui/input";
import { Button } from "components/ui/button";
import {
  ArrowDown,
  ArrowUp,
  Bot,
  DollarSign,
  ShoppingCart,
  FileArchive,
  Upload,
  Users,
  Search,
} from "lucide-react";
import PageWrapper from "components/PageWrapper";

const OrdersPage = () => {
  return (
    <PageWrapper>
      <section className="gap-6">
        <Card>
          <CardContent className="pt-3">
            <div className="flex justify-between pt-2 pb-6 px-2">
              <div className="flex flex-col gap-4">
                {/* <Input type="text" placeholder="Search..." className="w-80" /> */}
                <div className="max-w-md bg-gray-50">
                  <div className="relative">
                    <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                    <Input
                      placeholder="Search..."
                      // value={searchQuery}
                      // onChange={(e) => setSearchQuery(e.target.value)}
                      className="pl-10 bg-gray-50 focus-visible:ring-ring focus-visible:ring-0 focus-visible:ring-offset-0"
                    />
                  </div>
                </div>
                <div className="flex gap-3 py-4">
                  <Button
                    size="xs"
                    className="bg-gray-100 border bg-[#f1f5f9] text-gray-600 font-normal hover:bg-[#e2e8f0] hover:border-[#e2e8f0] transition-colors"
                  >
                    All Orders
                  </Button>
                  <Button
                    size="xs"
                    className="bg-gray-100 border bg-[#f1f5f9] text-gray-600 font-normal hover:bg-[#e2e8f0] hover:border-[#e2e8f0] transition-colors"
                  >
                    Pending
                  </Button>
                  <Button
                    size="xs"
                    className="bg-gray-100 border bg-[#f1f5f9] text-gray-600 font-normal hover:bg-[#e2e8f0] hover:border-[#e2e8f0] transition-colors"
                  >
                    Confirmed
                  </Button>
                  <Button
                    size="xs"
                    className="bg-gray-100 border bg-[#f1f5f9] text-gray-600 font-normal hover:bg-[#e2e8f0] hover:border-[#e2e8f0] transition-colors"
                  >
                    Shipped
                  </Button>
                </div>
              </div>
              <div>
                <Button
                  size="xs"
                  className="bg-gray-100 border bg-[#f1f5f9] text-gray-600 font-normal hover:bg-[#e2e8f0] hover:border-[#e2e8f0] transition-colors"
                >
                  Filter
                </Button>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-3 px-4 font-semibold text-gray-900 bg-[#f8fafc] text-sm">
                      ORDER ID
                    </th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-900 bg-[#f8fafc] text-sm">
                      BOM NAME
                    </th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-900 bg-[#f8fafc] text-sm">
                      SUPPLIER
                    </th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-900 bg-[#f8fafc] text-sm">
                      ORDER DATE
                    </th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-900 bg-[#f8fafc] text-sm">
                      STATUS
                    </th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-900 bg-[#f8fafc] text-sm">
                      TOTAL AMOUNT
                    </th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-900 bg-[#f8fafc] text-sm">
                      ESTIMATED DELIVERY
                    </th>
                    <th className="text-left py-3 px-4 font-semibold text-gray-900 bg-[#f8fafc] text-sm">
                      ACTIONS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="py-3 px-4">
                      <strong>ORD-2024-001</strong>
                    </td>
                    <td className="py-3 px-4">IoT Sensor Board v2.1</td>
                    <td className="py-3 px-4">Digi-Key Electronics</td>
                    <td className="py-3 px-4">22/01/2024</td>
                    <td className="py-3 px-4">
                      <span className="px-2 py-1 bg-orange-100 text-orange-700 rounded text-xs font-semibold">
                        Pending
                      </span>
                    </td>
                    <td className="py-3 px-4">$15,420 USD</td>
                    <td className="py-3 px-4">22/01/2024</td>
                    <td className="py-3 px-4">
                      <span className="px-2 py-1 bg-gray-100 text-gray-500 rounded text-xs font-semibold">
                        View
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      </section>
    </PageWrapper>
  );
};

export default OrdersPage;
